export default "__VITE_PUBLIC_ASSET__21966358__"